// extracted by mini-css-extract-plugin
export default {"container":"ndTVSlzGA0qhR0d6Mdow"};